"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlobConfigDeprecatedError = exports.DEPRECATED_CUSTOM_APP_CONFIG_BLOB_FIELDS = exports.CustomAppConfigSchema = exports.StyleVariantSchema = exports.StyleVariantMediaSchema = exports.StyleVariantStateSchema = exports.StylePresetSchema = exports.StyleTokenValueSchema = exports.StyleTokenNameSchema = exports.ContentRhythmSchema = exports.CtaTreatmentSchema = exports.TypographyScaleSchema = exports.MediaTreatmentSchema = exports.StyleRadiusSchema = exports.StyleElevationSchema = exports.StyleDensitySchema = exports.StyleSurfaceSchema = exports.StylePresetTargetSchema = exports.MotionSpecSchema = exports.ReducedMotionPolicySchema = exports.MotionEasingSchema = exports.MotionPresetSchema = exports.MotionTriggerSchema = exports.FormDefinitionRefSchema = exports.TranslationEntrySchema = exports.NavigationItemSchema = exports.PageDefinitionSchema = exports.DataSourceRegistrySchema = exports.DataSourceRefSchema = exports.CustomAppBrandingSettingsSchema = exports.CustomAppBrandingSocialImageSourceSchema = exports.CustomAppBrandingFaviconSourceSchema = exports.CustomAppBrandingLogoSourceSchema = exports.INITIAL_CUSTOM_APP_CONTENT_MODEL_BY_ROLE = exports.DEFAULT_CUSTOM_APP_CONTENT_MODEL_BY_ROLE = exports.CustomAppContentModelSchema = exports.INITIAL_CUSTOM_APP_DATABASE_ROLES = exports.CUSTOM_APP_ATTACHABLE_DATABASE_ROLES = exports.STANDARD_CUSTOM_APP_DATABASE_ROLES = exports.CUSTOM_APP_DATA_SOURCE_KEYS = exports.CustomAppDataSourceRoleSchema = exports.StandardDatabaseRoleSchema = exports.CustomAppPageStatusSchema = exports.PublicationModelSchema = exports.CustomAppPortalSettingsSchema = exports.CustomAppAccessSchema = exports.AudienceSchema = exports.RouteKindSchema = exports.DATA_SOURCE_REF_SCHEMA_VERSION = exports.CUSTOM_APP_CONFIG_SCHEMA_VERSION = void 0;
exports.getDefaultCustomAppContentModelForRole = getDefaultCustomAppContentModelForRole;
exports.getInitialCustomAppContentModelForRole = getInitialCustomAppContentModelForRole;
exports.createCustomAppDataSourceKey = createCustomAppDataSourceKey;
exports.validateNoDeprecatedBlobFields = validateNoDeprecatedBlobFields;
exports.isCustomAppPortalRegistrationEnabled = isCustomAppPortalRegistrationEnabled;
exports.planCustomAppBlockRemoval = planCustomAppBlockRemoval;
exports.mergeCustomAppRouteModulePages = mergeCustomAppRouteModulePages;
exports.mergeCustomAppRouteModuleNavigation = mergeCustomAppRouteModuleNavigation;
exports.getCustomAppConfigCompositionArtifactContractIssues = getCustomAppConfigCompositionArtifactContractIssues;
exports.assertCustomAppConfigCompositionArtifactContract = assertCustomAppConfigCompositionArtifactContract;
exports.sanitizeCustomAppManifestForMarketplaceExport = sanitizeCustomAppManifestForMarketplaceExport;
exports.sanitizeCustomAppConfigForMarketplaceAppExport = sanitizeCustomAppConfigForMarketplaceAppExport;
exports.createDefaultDataSourceRef = createDefaultDataSourceRef;
exports.createCustomAppDatabaseBindingsFromDataSources = createCustomAppDatabaseBindingsFromDataSources;
exports.projectCustomAppDatabaseBindingDataSources = projectCustomAppDatabaseBindingDataSources;
exports.withCustomAppDatabaseBinding = withCustomAppDatabaseBinding;
exports.withoutCustomAppDatabaseBinding = withoutCustomAppDatabaseBinding;
exports.withMovedCustomAppDatabaseBinding = withMovedCustomAppDatabaseBinding;
exports.createDefaultCustomAppConfig = createDefaultCustomAppConfig;
exports.createCustomAppConfigFromContentDbRef = createCustomAppConfigFromContentDbRef;
exports.resolveDataSourceRegistry = resolveDataSourceRegistry;
exports.resolveCustomAppBindingDataSources = resolveCustomAppBindingDataSources;
exports.resolveCustomAppDatabaseBindings = resolveCustomAppDatabaseBindings;
exports.createCustomAppCustomAppConfig = createCustomAppCustomAppConfig;
const zod_1 = require("zod");
const content_i18n_1 = require("./content-i18n");
const custom_app_contract_1 = require("./custom-app-contract");
const formula_1 = require("./formula");
const publication_contract_1 = require("./publication-contract");
exports.CUSTOM_APP_CONFIG_SCHEMA_VERSION = 1;
exports.DATA_SOURCE_REF_SCHEMA_VERSION = 2;
exports.RouteKindSchema = zod_1.z.enum([
    'static',
    'index',
    'detail',
    'form',
    'dashboard',
    'custom',
]);
exports.AudienceSchema = zod_1.z.enum([
    'public',
    'members',
    'internal',
    'portal',
]);
exports.CustomAppAccessSchema = custom_app_contract_1.CustomAppAccessModeSchema;
/**
 * Portal authoring policy stored with the Custom App draft and copied into
 * published snapshots. Absence means the historical open-registration
 * behaviour, so existing portal apps keep working until an editor changes it.
 */
exports.CustomAppPortalSettingsSchema = zod_1.z.object({
    registrationEnabled: zod_1.z.boolean(),
});
exports.PublicationModelSchema = zod_1.z.enum([
    'evergreen',
    'timestamped',
    'versioned',
    'submission',
]);
exports.CustomAppPageStatusSchema = publication_contract_1.PublicationStatusSchema;
exports.StandardDatabaseRoleSchema = zod_1.z.enum([
    'config',
    'branding',
    'pages',
    'navigation',
    'clusters',
    'topics',
    'users',
    'content',
    'articleBlocks',
    'translations',
    'forms',
    'submissions',
    // sl-sbux.8.1: database-native styling roles. Themes/MotionSpecs/
    // StylePresets/StyleVariants/CustomSheets/CustomHtmlBlocks replace the
    // legacy `ViewConfig.payload.{motion,styles,styleVariants,theme.customCss}`
    // blob fields. StyleVariants gets its own role (sl-sbux.8.1 amendment
    // 2026-05-23) because each variant has an independent CRUD lifecycle
    // and a many-to-one relation back to its preset.
    'themes',
    'motionSpecs',
    'stylePresets',
    'styleVariants',
    'customSheets',
    'customHtmlBlocks',
]);
exports.CustomAppDataSourceRoleSchema = zod_1.z.enum([
    'branding',
    'pages',
    'navigation',
    'clusters',
    'topics',
    'users',
    'content',
    'articleBlocks',
    'translations',
    'forms',
    'submissions',
    'themes',
    'motionSpecs',
    'stylePresets',
    'styleVariants',
    'customSheets',
    'customHtmlBlocks',
]);
exports.CUSTOM_APP_DATA_SOURCE_KEYS = {
    BRANDING: 'branding',
    PAGES: 'pages',
    NAVIGATION: 'navigation',
    CLUSTERS: 'clusters',
    TOPICS: 'topics',
    USERS: 'users',
    CONTENT: 'content',
    ARTICLE_BLOCKS: 'articleBlocks',
    TRANSLATIONS: 'translations',
    FORMS: 'forms',
    SUBMISSIONS: 'submissions',
    THEMES: 'themes',
    MOTION_SPECS: 'motionSpecs',
    STYLE_PRESETS: 'stylePresets',
    STYLE_VARIANTS: 'styleVariants',
    CUSTOM_SHEETS: 'customSheets',
    CUSTOM_HTML_BLOCKS: 'customHtmlBlocks',
};
exports.STANDARD_CUSTOM_APP_DATABASE_ROLES = [
    'branding',
    'pages',
    'navigation',
    'clusters',
    'topics',
    'users',
    'content',
    'articleBlocks',
    'translations',
    'forms',
    'submissions',
    'themes',
    'motionSpecs',
    'stylePresets',
    'styleVariants',
    'customSheets',
    'customHtmlBlocks',
];
exports.CUSTOM_APP_ATTACHABLE_DATABASE_ROLES = [
    'content',
    'users',
    'clusters',
    'topics',
];
/**
 * Databases that must exist for a newly-created Custom App before the user edits
 * routes. Route/preset-specific databases such as Knowledge Base topics or
 * article blocks are lazy-provisioned only after the user selects that preset.
 */
exports.INITIAL_CUSTOM_APP_DATABASE_ROLES = [
    'pages',
    'navigation',
    'users',
    'content',
];
exports.CustomAppContentModelSchema = zod_1.z.enum([
    'custom-app-branding',
    'custom-app-page',
    'custom-app-navigation',
    'custom-app-cluster',
    'custom-app-topic',
    'custom-app-user',
    'landing-content',
    'legal-page',
    'news-article',
    'knowledge-base-entry',
    'kb-article-block',
    'intranet-dashboard-item',
    'workflow-form',
    'workflow-submission',
    'development-demand',
    'development-epic',
    'development-work-item',
    'development-agent',
    'development-release',
    'development-release-event',
    'development-system',
    'development-decision',
    'translation-entry',
    'custom-app-theme',
    'motion-spec',
    'style-preset',
    'style-variant',
    'custom-sheet',
    'custom-html-block',
]);
exports.DEFAULT_CUSTOM_APP_CONTENT_MODEL_BY_ROLE = {
    branding: 'custom-app-branding',
    pages: 'custom-app-page',
    navigation: 'custom-app-navigation',
    clusters: 'custom-app-cluster',
    topics: 'custom-app-topic',
    users: 'custom-app-user',
    content: 'landing-content',
    articleBlocks: 'kb-article-block',
    translations: 'translation-entry',
    forms: 'workflow-form',
    submissions: 'workflow-submission',
    themes: 'custom-app-theme',
    motionSpecs: 'motion-spec',
    stylePresets: 'style-preset',
    styleVariants: 'style-variant',
    customSheets: 'custom-sheet',
    customHtmlBlocks: 'custom-html-block',
};
exports.INITIAL_CUSTOM_APP_CONTENT_MODEL_BY_ROLE = {
    ...exports.DEFAULT_CUSTOM_APP_CONTENT_MODEL_BY_ROLE,
};
function getDefaultCustomAppContentModelForRole(role) {
    return exports.DEFAULT_CUSTOM_APP_CONTENT_MODEL_BY_ROLE[role];
}
function getInitialCustomAppContentModelForRole(role) {
    return exports.INITIAL_CUSTOM_APP_CONTENT_MODEL_BY_ROLE[role];
}
function createCustomAppDataSourceKey(input) {
    return input.contentModel ===
        getDefaultCustomAppContentModelForRole(input.role)
        ? input.role
        : `${input.role}:${input.contentModel}`;
}
exports.CustomAppBrandingLogoSourceSchema = zod_1.z.enum([
    'workspace',
    'custom',
]);
exports.CustomAppBrandingFaviconSourceSchema = zod_1.z.enum(['logo', 'custom']);
exports.CustomAppBrandingSocialImageSourceSchema = zod_1.z.enum([
    'logo',
    'custom',
]);
exports.CustomAppBrandingSettingsSchema = zod_1.z
    .object({
    brandingId: zod_1.z.string().min(1),
    displayName: zod_1.z.string().min(1).nullable().optional(),
    logoSource: exports.CustomAppBrandingLogoSourceSchema,
    logoBlobId: zod_1.z.string().min(1).nullable().optional(),
    faviconSource: exports.CustomAppBrandingFaviconSourceSchema,
    faviconBlobId: zod_1.z.string().min(1).nullable().optional(),
    socialImageSource: exports.CustomAppBrandingSocialImageSourceSchema.optional(),
    socialImageBlobId: zod_1.z.string().min(1).nullable().optional(),
    updatedAt: zod_1.z.string().min(1).nullable().optional(),
})
    .strict();
exports.DataSourceRefSchema = zod_1.z
    .object({
    version: zod_1.z.literal(exports.DATA_SOURCE_REF_SCHEMA_VERSION),
    key: zod_1.z.string().min(1),
    semanticKey: zod_1.z.string().min(1).optional(),
    role: exports.CustomAppDataSourceRoleSchema,
    contentModel: exports.CustomAppContentModelSchema,
    databaseId: zod_1.z.string().min(1),
    docId: zod_1.z.string().min(1),
    blockId: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
})
    .strict();
exports.DataSourceRegistrySchema = zod_1.z.record(zod_1.z.string().min(1), exports.DataSourceRefSchema);
exports.PageDefinitionSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    routeKind: exports.RouteKindSchema,
    audience: exports.AudienceSchema,
    templateKey: zod_1.z.string().min(1),
    collectionRole: zod_1.z.string().min(1).nullable(),
    publicationModel: exports.PublicationModelSchema,
    status: exports.CustomAppPageStatusSchema,
    path: zod_1.z.string().min(1),
    parentPageId: zod_1.z.string().min(1).nullable().optional(),
    order: zod_1.z.number().int().nonnegative().optional(),
    titleFormula: formula_1.FormulaSchema.nullable().optional(),
    seoIndexing: zod_1.z.boolean().optional(),
    dataSourceKeys: zod_1.z.array(zod_1.z.string().min(1)),
    navigationKey: zod_1.z.string().min(1).nullable().optional(),
    i18nPolicy: content_i18n_1.ContentI18nPolicySchema.optional(),
    rowSelection: zod_1.z
        .object({
        type: zod_1.z.literal('fixed-slug'),
        sourceKey: zod_1.z.string().min(1),
        slug: zod_1.z.string().min(1),
    })
        .strict()
        .optional(),
})
    .strict();
exports.NavigationItemSchema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    labelFormula: formula_1.FormulaSchema.nullable().optional(),
    labelsI18n: zod_1.z.record(zod_1.z.string().min(1), zod_1.z.string().min(1)).optional(),
    pageId: zod_1.z.string().min(1).nullable().optional(),
    href: zod_1.z.string().min(1).nullable().optional(),
    parentId: zod_1.z.string().min(1).nullable().optional(),
    order: zod_1.z.number().int().nonnegative(),
});
exports.TranslationEntrySchema = content_i18n_1.ContentTranslationEntrySchema;
exports.FormDefinitionRefSchema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    formSourceKey: zod_1.z.string().min(1),
    submissionSourceKey: zod_1.z.string().min(1),
});
exports.MotionTriggerSchema = zod_1.z.enum([
    'none',
    'on-enter',
    'on-hover',
    'on-click',
]);
exports.MotionPresetSchema = zod_1.z.enum([
    'none',
    'fade-in',
    'slide-up',
    'slide-down',
    'slide-left',
    'slide-right',
    'scale-in',
    'blur-in',
    'reveal',
]);
exports.MotionEasingSchema = zod_1.z.enum([
    'linear',
    'ease',
    'ease-in',
    'ease-out',
    'ease-in-out',
    'standard',
    'emphasized',
]);
exports.ReducedMotionPolicySchema = zod_1.z.enum(['preserve', 'fade', 'static']);
exports.MotionSpecSchema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    trigger: exports.MotionTriggerSchema,
    preset: exports.MotionPresetSchema,
    durationMs: zod_1.z.number().int().min(0).max(5000),
    delayMs: zod_1.z.number().int().min(0).max(5000),
    staggerMs: zod_1.z.number().int().min(0).max(1000).default(0),
    easing: exports.MotionEasingSchema,
    reducedMotionPolicy: exports.ReducedMotionPolicySchema,
});
exports.StylePresetTargetSchema = zod_1.z.enum([
    'section',
    'hero',
    'card',
    'form',
    'panel',
]);
exports.StyleSurfaceSchema = zod_1.z.enum([
    'quiet',
    'raised',
    'editorial',
    'form',
    'inset',
]);
exports.StyleDensitySchema = zod_1.z.enum(['compact', 'standard', 'spacious']);
exports.StyleElevationSchema = zod_1.z.enum(['none', 'sm', 'md']);
exports.StyleRadiusSchema = zod_1.z.enum(['none', 'sm', 'md']);
exports.MediaTreatmentSchema = zod_1.z.enum([
    'none',
    'thumbnail',
    'cover',
    'wide',
]);
exports.TypographyScaleSchema = zod_1.z.enum(['compact', 'body', 'display']);
exports.CtaTreatmentSchema = zod_1.z.enum(['link', 'button', 'quiet']);
exports.ContentRhythmSchema = zod_1.z.enum(['tight', 'normal', 'generous']);
exports.StyleTokenNameSchema = zod_1.z.enum([
    'surface',
    'padding',
    'gap',
    'radius',
    'shadow',
    'mediaRatio',
    'fontScale',
    'ctaRadius',
]);
exports.StyleTokenValueSchema = zod_1.z.enum([
    'none',
    'quiet',
    'raised',
    'editorial',
    'form',
    'inset',
    'compact',
    'standard',
    'spacious',
    'sm',
    'md',
    'thumbnail',
    'cover',
    'wide',
    'body',
    'display',
    'link',
    'button',
    'generous',
]);
exports.StylePresetSchema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    target: exports.StylePresetTargetSchema,
    surface: exports.StyleSurfaceSchema,
    density: exports.StyleDensitySchema,
    elevation: exports.StyleElevationSchema,
    radius: exports.StyleRadiusSchema,
    mediaTreatment: exports.MediaTreatmentSchema,
    typographyScale: exports.TypographyScaleSchema,
    ctaTreatment: exports.CtaTreatmentSchema,
    contentRhythm: exports.ContentRhythmSchema,
});
exports.StyleVariantStateSchema = zod_1.z.enum(['hover', 'focus', 'active']);
exports.StyleVariantMediaSchema = zod_1.z.enum([
    'base',
    'mobile',
    'desktop',
    'reduced-motion',
]);
exports.StyleVariantSchema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    presetId: zod_1.z.string().min(1),
    state: exports.StyleVariantStateSchema.nullable().optional(),
    media: exports.StyleVariantMediaSchema,
    tokens: zod_1.z.record(exports.StyleTokenNameSchema, exports.StyleTokenValueSchema),
});
/**
 * sl-sbux.8.2 B4: motion/styles/styleVariants moved out of CustomAppConfig into
 * dedicated standard databases (motionSpecs, stylePresets, styleVariants).
 * Raw `CustomAppConfig` blobs that still carry these legacy fields are rejected
 * fail-loud by {@link validateNoDeprecatedBlobFields} BEFORE Zod runs, so
 * stale persisted payloads surface a `BlobConfigDeprecatedError` instead of
 * silently shedding data through `.strip()`.
 */
const CustomAppConfigShapeSchema = zod_1.z.object({
    schemaVersion: zod_1.z.literal(exports.CUSTOM_APP_CONFIG_SCHEMA_VERSION),
    productMode: custom_app_contract_1.CustomAppProductModeSchema.optional(),
    access: exports.CustomAppAccessSchema.optional(),
    defaultLocale: zod_1.z.string().min(2),
    availableLocales: zod_1.z.array(zod_1.z.string().min(2)).min(1),
    dataSources: zod_1.z.unknown().optional(),
    databaseBindings: custom_app_contract_1.CustomAppDatabaseBindingRegistrySchema,
    customAppComposition: custom_app_contract_1.CustomAppCompositionSchema.optional(),
    /** Workspace-owned definitions; Marketplace is provenance, never runtime. */
    appBlockDefinitions: zod_1.z.record(custom_app_contract_1.CustomAppBlockDefinitionSchema).default({}),
    customApp: custom_app_contract_1.CustomAppManifestSchema.optional(),
    customAppArtifact: custom_app_contract_1.CustomAppArtifactSchema.optional(),
    customAppLifecycle: custom_app_contract_1.CustomAppLifecycleSchema.optional(),
    pages: zod_1.z.array(exports.PageDefinitionSchema),
    navigation: zod_1.z.array(exports.NavigationItemSchema),
    translations: zod_1.z.array(exports.TranslationEntrySchema),
    forms: zod_1.z.array(exports.FormDefinitionRefSchema),
    i18nPolicy: content_i18n_1.ContentI18nPolicySchema.optional(),
    stripImageMetadata: zod_1.z.boolean().default(true),
    portalSettings: exports.CustomAppPortalSettingsSchema.optional(),
});
function validateCustomAppDataSourceProjection(customAppConfig, ctx) {
    if (customAppConfig.dataSources !== undefined) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['dataSources'],
            message: 'Custom App dataSources is derived from databaseBindings and must not be persisted',
        });
    }
    customAppConfig.pages.forEach((page, pageIndex) => {
        if (page.rowSelection &&
            !page.dataSourceKeys.includes(page.rowSelection.sourceKey)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                path: ['pages', pageIndex, 'rowSelection', 'sourceKey'],
                message: 'Fixed row selection sourceKey must be declared in page dataSourceKeys',
            });
        }
    });
    if (customAppConfig.productMode !== 'custom-app')
        return;
    if (!customAppConfig.databaseBindings) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['databaseBindings'],
            message: 'Custom App databaseBindings must be declared as the canonical database source',
        });
        return;
    }
    for (const [sourceKey, binding] of Object.entries(customAppConfig.databaseBindings)) {
        if (!exports.CustomAppDataSourceRoleSchema.safeParse(binding.role).success) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                path: ['databaseBindings', sourceKey, 'role'],
                message: 'Custom App database binding role must be a known Custom App data source role',
            });
        }
        if (!exports.CustomAppContentModelSchema.safeParse(binding.contentModel).success) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                path: ['databaseBindings', sourceKey, 'contentModel'],
                message: 'Custom App database binding contentModel must be a known Custom App content model',
            });
        }
    }
}
function withDerivedDataSources(customAppConfig) {
    const { dataSources: _dataSources, ...storedConfig } = customAppConfig;
    const configWithDerivedDataSources = storedConfig;
    Object.defineProperty(configWithDerivedDataSources, 'dataSources', {
        configurable: false,
        enumerable: false,
        get: () => projectCustomAppDatabaseBindingDataSources(storedConfig.databaseBindings),
    });
    return configWithDerivedDataSources;
}
function stripRuntimeDataSourcesProjection(input) {
    if (!input || typeof input !== 'object' || Array.isArray(input))
        return input;
    const record = input;
    if ('dataSources' in record &&
        !Object.prototype.propertyIsEnumerable.call(record, 'dataSources')) {
        return Object.fromEntries(Object.entries(record).filter(([key]) => key !== 'dataSources'));
    }
    return input;
}
exports.CustomAppConfigSchema = zod_1.z
    .preprocess(stripRuntimeDataSourcesProjection, CustomAppConfigShapeSchema)
    .superRefine(validateCustomAppDataSourceProjection)
    .transform(withDerivedDataSources);
function stableJsonValue(value) {
    if (Array.isArray(value))
        return value.map(stableJsonValue);
    if (!value || typeof value !== 'object')
        return value;
    return Object.fromEntries(Object.entries(value)
        .sort(([left], [right]) => left.localeCompare(right))
        .map(([key, child]) => [key, stableJsonValue(child)]));
}
function stableJson(value) {
    return JSON.stringify(stableJsonValue(value));
}
/**
 * Fields that used to live inline on {@link CustomAppConfig} but now belong to a
 * dedicated standard database. A persisted payload carrying any of these
 * fields is a sign of stale data and must be re-authored against the new
 * styling databases — no backfill, no silent migration.
 */
exports.DEPRECATED_CUSTOM_APP_CONFIG_BLOB_FIELDS = [
    'motion',
    'styles',
    'styleVariants',
];
class BlobConfigDeprecatedError extends Error {
    constructor(fields) {
        super(`CustomAppConfig carries deprecated blob field(s): ${fields.join(', ')}. Motion specs / style presets / style variants live in dedicated standard databases since sl-sbux.8.2 — re-author the affected app instead of patching the blob.`);
        this.name = 'BlobConfigDeprecatedError';
        this.fields = fields;
    }
}
exports.BlobConfigDeprecatedError = BlobConfigDeprecatedError;
/**
 * Throw if `raw` carries any of the deprecated blob fields. Call this BEFORE
 * `CustomAppConfigSchema.parse(raw)` so the failure surfaces at the persistence
 * boundary rather than being silently stripped by Zod.
 */
function validateNoDeprecatedBlobFields(raw) {
    if (!raw || typeof raw !== 'object')
        return;
    const offenders = [];
    for (const field of exports.DEPRECATED_CUSTOM_APP_CONFIG_BLOB_FIELDS) {
        if (field in raw) {
            offenders.push(field);
        }
    }
    if (offenders.length > 0) {
        throw new BlobConfigDeprecatedError(offenders);
    }
}
function isCustomAppPortalRegistrationEnabled(customAppConfig) {
    return customAppConfig.portalSettings?.registrationEnabled !== false;
}
/**
 * Canonical, side-effect free impact projection for removing one App Block.
 * A database binding is removed from the app only when this mount is its sole
 * consumer and the database was created for the app. Attached or shared
 * resources are always retained.
 */
function planCustomAppBlockRemoval(customAppConfig, mountId) {
    const composition = customAppConfig.customAppComposition;
    const mount = composition?.mounts.find(item => item.mountId === mountId);
    if (!mount)
        throw new Error(`Custom App Block mount ${mountId} not found`);
    const definition = customAppConfig.appBlockDefinitions[mount.appBlockId];
    if (!definition) {
        throw new Error(`Custom App Block definition ${mount.appBlockId} not found`);
    }
    const output = (0, custom_app_contract_1.compileCustomAppBlockMount)({ definition, mount });
    const removedRoutePaths = new Set(output.routes.map(route => route.path));
    const otherSourceKeys = new Set();
    for (const otherMount of composition?.mounts ?? []) {
        if (otherMount.mountId === mountId)
            continue;
        const otherDefinition = customAppConfig.appBlockDefinitions[otherMount.appBlockId];
        if (!otherDefinition)
            continue;
        const otherOutput = (0, custom_app_contract_1.compileCustomAppBlockMount)({
            definition: otherDefinition,
            mount: otherMount,
        });
        for (const sourceKey of otherOutput.dataSourceKeys) {
            otherSourceKeys.add(sourceKey);
        }
    }
    for (const page of customAppConfig.pages) {
        if (removedRoutePaths.has(page.path))
            continue;
        for (const sourceKey of page.dataSourceKeys)
            otherSourceKeys.add(sourceKey);
    }
    const resourceLabels = new Map(output.resources.map(resource => [
        resource.sourceKey,
        resource.label ??
            customAppConfig.databaseBindings[resource.sourceKey]?.label ??
            resource.sourceKey,
    ]));
    const removedDataSources = [];
    const retainedDataSources = [];
    for (const sourceKey of output.dataSourceKeys) {
        const binding = customAppConfig.databaseBindings[sourceKey];
        if (!binding || binding.status !== 'active')
            continue;
        const label = resourceLabels.get(sourceKey) ?? binding.label;
        if (binding.ownership === 'custom-app-owned' &&
            !otherSourceKeys.has(sourceKey)) {
            removedDataSources.push({
                sourceKey,
                label,
                reason: 'exclusive-owned',
            });
        }
        else {
            retainedDataSources.push({
                sourceKey,
                label,
                reason: binding.ownership === 'attached-existing'
                    ? 'attached-existing'
                    : 'shared',
            });
        }
    }
    return {
        mountId,
        appBlockId: mount.appBlockId,
        title: definition.title,
        routePaths: output.routes.map(route => route.path),
        actionLabels: output.actions.map(action => action.label),
        removedDataSources,
        retainedDataSources,
    };
}
function normalizeCustomAppRoutePath(path) {
    const trimmed = path.trim();
    return trimmed.length > 0 ? trimmed : '/';
}
function compareOptionalCustomAppOrder(left, right) {
    return ((left.order ?? 0) - (right.order ?? 0) || left.id.localeCompare(right.id));
}
function compareCustomAppOrder(left, right) {
    return left.order - right.order || left.id.localeCompare(right.id);
}
/**
 * Database-backed authoring may retain an older row for a path now owned by a
 * compiled route module. The compiled artifact is authoritative for those
 * paths; unrelated user-authored routes remain database-backed.
 */
function mergeCustomAppRouteModulePages(customAppConfig, parsedPages) {
    const routeModules = customAppConfig.customAppArtifact?.routeModules ?? [];
    if (routeModules.length === 0)
        return [...parsedPages];
    const ownedPaths = new Set();
    for (const routeModule of routeModules) {
        ownedPaths.add(normalizeCustomAppRoutePath(routeModule.rootRoutePath));
        for (const routePath of routeModule.routePaths) {
            ownedPaths.add(normalizeCustomAppRoutePath(routePath));
        }
    }
    const modulePages = customAppConfig.pages.filter(page => ownedPaths.has(normalizeCustomAppRoutePath(page.path)));
    if (modulePages.length === 0)
        return [...parsedPages];
    const modulePageIds = new Set(modulePages.map(page => page.id));
    const modulePagePaths = new Set(modulePages.map(page => normalizeCustomAppRoutePath(page.path)));
    return [
        ...parsedPages.filter(page => !modulePageIds.has(page.id) &&
            !modulePagePaths.has(normalizeCustomAppRoutePath(page.path))),
        ...modulePages,
    ].sort(compareOptionalCustomAppOrder);
}
/** Keeps navigation aligned with the route-module page projection. */
function mergeCustomAppRouteModuleNavigation(customAppConfig, parsedNavigation, pages) {
    const routeModules = customAppConfig.customAppArtifact?.routeModules ?? [];
    if (routeModules.length === 0)
        return [...parsedNavigation];
    const pageIds = new Set(pages.map(page => page.id));
    const ownedNavigationIds = new Set(routeModules.flatMap(routeModule => routeModule.navigationItemIds));
    const moduleNavigation = customAppConfig.navigation.filter(item => ownedNavigationIds.has(item.id) &&
        (!item.pageId || pageIds.has(item.pageId)));
    if (moduleNavigation.length === 0) {
        return parsedNavigation.filter(item => !item.pageId || pageIds.has(item.pageId));
    }
    const moduleNavigationPageIds = new Set(moduleNavigation
        .map(item => item.pageId)
        .filter((pageId) => typeof pageId === 'string'));
    return [
        ...parsedNavigation.filter(item => {
            if (ownedNavigationIds.has(item.id))
                return false;
            if (item.pageId && !pageIds.has(item.pageId))
                return false;
            if (item.pageId && moduleNavigationPageIds.has(item.pageId)) {
                return false;
            }
            return true;
        }),
        ...moduleNavigation,
    ].sort(compareCustomAppOrder);
}
function getCustomAppConfigCompositionArtifactContractIssues(customAppConfig) {
    if (customAppConfig.productMode !== 'custom-app')
        return [];
    const issues = [];
    const composition = customAppConfig.customAppComposition;
    const manifest = customAppConfig.customApp;
    const artifact = customAppConfig.customAppArtifact;
    if (!composition) {
        issues.push('customAppComposition is required for Custom Apps');
    }
    if (!manifest) {
        issues.push('customApp manifest is required for Custom Apps');
    }
    if (!artifact) {
        issues.push('customAppArtifact is required for Custom Apps');
    }
    if (!composition || !manifest || !artifact)
        return issues;
    if (!artifact.provenance) {
        issues.push('customAppArtifact requires composition compiler provenance');
    }
    else {
        if (artifact.provenance.compositionId !== composition.compositionId) {
            issues.push(`customAppArtifact provenance compositionId ${artifact.provenance.compositionId} does not match customAppComposition ${composition.compositionId}`);
        }
        if (artifact.provenance.compositionRevision !== composition.revision) {
            issues.push(`customAppArtifact provenance revision ${artifact.provenance.compositionRevision} does not match customAppComposition revision ${composition.revision}`);
        }
    }
    if (manifest.appId !== composition.shell.appId) {
        issues.push(`customApp manifest appId ${manifest.appId} does not match composition shell appId ${composition.shell.appId}`);
    }
    if (manifest.name !== composition.shell.name) {
        issues.push(`customApp manifest name ${manifest.name} does not match composition shell name ${composition.shell.name}`);
    }
    if (stableJson(manifest) !== stableJson(artifact.manifest)) {
        issues.push('customApp manifest must match customAppArtifact.manifest');
    }
    if (composition.mounts.length === 0) {
        const compiledArtifact = (0, custom_app_contract_1.compileCustomAppComposition)({
            composition,
            artifactId: artifact.artifactId,
            now: artifact.createdAt,
        });
        const expectedArtifact = custom_app_contract_1.CustomAppArtifactSchema.parse({
            ...compiledArtifact,
            manifest: (0, custom_app_contract_1.withCustomAppInteractionContract)(compiledArtifact.manifest),
        });
        if (stableJson(artifact.manifest) !== stableJson(expectedArtifact.manifest)) {
            issues.push('customAppArtifact manifest does not match compiled shell');
        }
        if (stableJson(artifact.routeModules) !==
            stableJson(expectedArtifact.routeModules)) {
            issues.push('customAppArtifact routeModules do not match compiled shell');
        }
        // Storage replaces inline text with an immutable blob reference. The
        // compiler contract describes content, not that transport representation.
        const fileKeys = Object.keys(artifact.files);
        const expectedFiles = expectedArtifact.files;
        const filesMatch = fileKeys.length === Object.keys(expectedFiles).length &&
            fileKeys.every(key => {
                const actual = artifact.files[key];
                const expected = expectedFiles[key];
                return (expected !== undefined &&
                    actual.path === expected.path &&
                    actual.contentType === expected.contentType &&
                    actual.sha256 === expected.sha256 &&
                    actual.bytes === expected.bytes &&
                    (actual.text !== undefined
                        ? actual.text === expected.text
                        : Boolean(actual.storageKey)));
            });
        if (!filesMatch) {
            issues.push('customAppArtifact files do not match compiled shell');
        }
    }
    else {
        const hasRootRouteMount = composition.mounts.some(mount => (mount.entryRoutePath ?? mount.routePrefix) ===
            composition.shell.rootRoutePath);
        const mountIds = new Set(composition.mounts.map(mount => mount.mountId));
        const ownerMatchesComposition = (ownerId) => {
            if (!hasRootRouteMount && ownerId === 'shell')
                return true;
            return [...mountIds].some(mountId => ownerId === mountId || ownerId.startsWith(`${mountId}:`));
        };
        for (const routeModule of artifact.routeModules) {
            if (ownerMatchesComposition(routeModule.id))
                continue;
            issues.push(`customAppArtifact routeModule ${routeModule.id} is not owned by customAppComposition`);
        }
    }
    return issues;
}
function assertCustomAppConfigCompositionArtifactContract(customAppConfig) {
    const issues = getCustomAppConfigCompositionArtifactContractIssues(customAppConfig);
    if (issues.length === 0)
        return;
    throw new Error(`Custom App composition/artifact contract violated: ${issues.join('; ')}`);
}
function sanitizeCustomAppManifestForMarketplaceExport(manifest) {
    return (0, custom_app_contract_1.withCustomAppInteractionContract)({
        ...manifest,
        actions: manifest.actions.map(action => {
            if (action.type !== 'automationRun')
                return action;
            const { automationId: _automationId, workflowId: _workflowId, ...templateAction } = action;
            return templateAction;
        }),
    });
}
function sanitizeCustomAppConfigForMarketplaceAppExport(customAppConfig) {
    const customApp = customAppConfig.customApp
        ? sanitizeCustomAppManifestForMarketplaceExport(customAppConfig.customApp)
        : undefined;
    const customAppArtifact = customAppConfig.customAppArtifact
        ? custom_app_contract_1.CustomAppArtifactSchema.parse({
            ...customAppConfig.customAppArtifact,
            manifest: sanitizeCustomAppManifestForMarketplaceExport(customAppConfig.customAppArtifact.manifest),
        })
        : undefined;
    return exports.CustomAppConfigSchema.parse({
        ...customAppConfig,
        customApp,
        customAppArtifact,
        customAppLifecycle: undefined,
        databaseBindings: customAppConfig.databaseBindings
            ? Object.fromEntries(Object.entries(customAppConfig.databaseBindings).map(([key, binding]) => {
                const { grantedByUserId: _grantedByUserId, ...templateBinding } = binding;
                return [key, templateBinding];
            }))
            : undefined,
    });
}
function createDefaultDataSourceRef(input) {
    return exports.DataSourceRefSchema.parse({
        version: exports.DATA_SOURCE_REF_SCHEMA_VERSION,
        ...input,
    });
}
function createCustomAppDatabaseBindingsFromDataSources(dataSources) {
    const now = '1970-01-01T00:00:00.000Z';
    return Object.fromEntries(Object.entries(dataSources).map(([sourceKey, ref]) => [
        sourceKey,
        (0, custom_app_contract_1.createCustomAppDatabaseBinding)({
            sourceKey,
            semanticKey: ref.semanticKey,
            role: ref.role,
            contentModel: ref.contentModel,
            databaseId: ref.databaseId,
            docId: ref.docId,
            blockId: ref.blockId,
            label: ref.label,
            ownership: 'custom-app-owned',
            audience: 'internal',
            now,
        }),
    ]));
}
function removeString(values, value) {
    return values.filter(current => current !== value);
}
function dataSourceFromDatabaseBinding(binding) {
    return createDefaultDataSourceRef({
        key: binding.sourceKey,
        semanticKey: binding.semanticKey === binding.sourceKey
            ? undefined
            : binding.semanticKey,
        role: exports.CustomAppDataSourceRoleSchema.parse(binding.role),
        contentModel: exports.CustomAppContentModelSchema.parse(binding.contentModel),
        databaseId: binding.databaseId,
        docId: binding.placement.docId,
        blockId: binding.placement.blockId,
        label: binding.label,
    });
}
function projectCustomAppDatabaseBindingDataSources(bindings) {
    const activeEntries = Object.entries(bindings ?? {}).filter(([, binding]) => binding.status === 'active');
    if (activeEntries.length === 0)
        return {};
    return Object.fromEntries(activeEntries.map(([sourceKey, binding]) => [
        sourceKey,
        dataSourceFromDatabaseBinding(binding),
    ]));
}
function withCustomAppDatabaseBinding(input) {
    const { customAppConfig, binding } = input;
    const databaseBindings = {
        ...(customAppConfig.databaseBindings ?? {}),
        [binding.sourceKey]: binding,
    };
    return exports.CustomAppConfigSchema.parse({
        ...customAppConfig,
        productMode: customAppConfig.productMode ?? input.defaultProductMode ?? 'custom-app',
        databaseBindings,
    });
}
function withoutCustomAppDatabaseBinding(input) {
    const { customAppConfig, sourceKey, binding } = input;
    const { [sourceKey]: _removedBinding, ...existingBindings } = customAppConfig.databaseBindings ?? {};
    const databaseBindings = {
        ...existingBindings,
        [sourceKey]: (0, custom_app_contract_1.bumpCustomAppDatabaseBindingRevision)(binding, {
            status: 'detached',
            now: input.now,
        }),
    };
    return exports.CustomAppConfigSchema.parse({
        ...customAppConfig,
        databaseBindings,
        pages: customAppConfig.pages.map(page => ({
            ...page,
            dataSourceKeys: removeString(page.dataSourceKeys, sourceKey),
        })),
    });
}
function withMovedCustomAppDatabaseBinding(input) {
    const movedBinding = (0, custom_app_contract_1.bumpCustomAppDatabaseBindingRevision)(input.binding, {
        status: 'active',
        grantedByUserId: input.grantedByUserId,
        placement: {
            docId: input.docId,
            blockId: input.blockId,
        },
        now: input.now,
    });
    return withCustomAppDatabaseBinding({
        customAppConfig: input.customAppConfig,
        binding: movedBinding,
    });
}
function createDefaultCustomAppConfig(input) {
    const productMode = input.productMode ?? 'custom-app';
    const databaseBindings = createCustomAppDatabaseBindingsFromDataSources(input.dataSources);
    const dataSources = projectCustomAppDatabaseBindingDataSources(databaseBindings);
    const sourceKeys = Object.keys(dataSources);
    return exports.CustomAppConfigSchema.parse({
        schemaVersion: exports.CUSTOM_APP_CONFIG_SCHEMA_VERSION,
        productMode,
        access: 'public',
        defaultLocale: input.defaultLocale ?? 'en',
        availableLocales: [input.defaultLocale ?? 'en'],
        databaseBindings,
        pages: [
            {
                id: 'home',
                routeKind: 'static',
                audience: 'public',
                templateKey: 'landing',
                collectionRole: null,
                publicationModel: 'evergreen',
                status: 'published',
                path: '/',
                parentPageId: null,
                order: 0,
                titleFormula: { type: 'value', value: input.title },
                dataSourceKeys: sourceKeys,
                navigationKey: exports.CUSTOM_APP_DATA_SOURCE_KEYS.NAVIGATION,
                i18nPolicy: content_i18n_1.DEFAULT_CONTENT_I18N_POLICY,
            },
        ],
        navigation: [],
        translations: [],
        forms: [],
        i18nPolicy: content_i18n_1.DEFAULT_CONTENT_I18N_POLICY,
        stripImageMetadata: true,
    });
}
function createCustomAppConfigFromContentDbRef(input) {
    if (!input.contentDbRef)
        return undefined;
    const customAppConfig = createDefaultCustomAppConfig({
        title: input.name,
        defaultLocale: input.defaultLocale,
        productMode: input.productMode,
        dataSources: {
            [exports.CUSTOM_APP_DATA_SOURCE_KEYS.CONTENT]: createDefaultDataSourceRef({
                key: exports.CUSTOM_APP_DATA_SOURCE_KEYS.CONTENT,
                role: 'content',
                contentModel: input.contentDbRef.contentModel,
                databaseId: input.contentDbRef.databaseId,
                docId: input.contentDbRef.docId,
                blockId: input.contentDbRef.blockId,
                label: 'Content',
            }),
        },
    });
    return exports.CustomAppConfigSchema.parse({
        ...customAppConfig,
        pages: customAppConfig.pages.map(page => page.path === '/'
            ? {
                ...page,
                templateKey: 'custom',
                collectionRole: null,
                dataSourceKeys: [exports.CUSTOM_APP_DATA_SOURCE_KEYS.CONTENT],
                navigationKey: null,
            }
            : page),
    });
}
function resolveDataSourceRegistry(input) {
    if (input.customAppConfig) {
        const dataSources = resolveCustomAppBindingDataSources(input.customAppConfig);
        if (Object.keys(dataSources).length > 0)
            return dataSources;
    }
    if (!input.contentDbRef)
        return {};
    return {
        [exports.CUSTOM_APP_DATA_SOURCE_KEYS.CONTENT]: createDefaultDataSourceRef({
            key: exports.CUSTOM_APP_DATA_SOURCE_KEYS.CONTENT,
            role: 'content',
            contentModel: input.contentDbRef.contentModel,
            databaseId: input.contentDbRef.databaseId,
            docId: input.contentDbRef.docId,
            blockId: input.contentDbRef.blockId,
            label: 'Content',
        }),
    };
}
function resolveCustomAppBindingDataSources(customAppConfig) {
    if (customAppConfig?.productMode !== 'custom-app')
        return {};
    return projectCustomAppDatabaseBindingDataSources(customAppConfig.databaseBindings);
}
function resolveCustomAppDatabaseBindings(input) {
    return input.customAppConfig?.databaseBindings ?? {};
}
function createCustomAppCustomAppConfig(input) {
    const customAppConfig = createDefaultCustomAppConfig({
        title: input.name,
        defaultLocale: input.defaultLocale,
        productMode: 'custom-app',
        dataSources: {},
    });
    const customAppComposition = custom_app_contract_1.CustomAppCompositionSchema.parse({
        schemaVersion: 1,
        compositionId: 'custom-app-shell',
        revision: 1,
        updatedAt: '1970-01-01T00:00:00.000Z',
        shell: {
            appId: 'custom',
            name: input.name,
            entry: 'index.html',
            ...(input.exposureProfile
                ? { exposureProfile: input.exposureProfile }
                : {}),
            rootRoutePath: '/',
        },
        mounts: [],
    });
    const compiledArtifact = (0, custom_app_contract_1.compileCustomAppComposition)({
        composition: customAppComposition,
        artifactId: 'custom-app-shell',
        now: '1970-01-01T00:00:00.000Z',
    });
    const customAppArtifact = custom_app_contract_1.CustomAppArtifactSchema.parse({
        ...compiledArtifact,
        manifest: (0, custom_app_contract_1.withCustomAppInteractionContract)(compiledArtifact.manifest),
    });
    const customApp = customAppArtifact.manifest;
    const exposurePolicy = (0, custom_app_contract_1.deriveCustomAppExposureProfile)(customAppComposition.shell.exposureProfile);
    return exports.CustomAppConfigSchema.parse({
        ...customAppConfig,
        access: exposurePolicy.access,
        customAppComposition,
        customApp,
        customAppArtifact,
        pages: customAppConfig.pages.map(page => ({
            ...page,
            routeKind: 'custom',
            templateKey: 'custom-app',
            dataSourceKeys: [],
            navigationKey: null,
        })),
        navigation: [
            {
                id: 'home',
                labelFormula: { type: 'value', value: input.name },
                pageId: 'home',
                href: null,
                parentId: null,
                order: 0,
            },
        ],
    });
}
